import {
    open_drawer,
    close_drawer,
    open_btm_drawer,
    close_btm_drawer,
    toggle_drawer_Pin,
    toggle_drawer_Fix,
    drawer_content,
    drawer_Filters
} from './DrawerActions';
 

const drawerState = {
    isDrawerOpen: false,
    isBtmDrawerOpen: false,
    isDrawerFix: true,
    isDrawerPin: false,
    currentTab: 'menu',
    filters: null
}

export const handleDrawer = (state = drawerState, action) =>{
    switch (action.type) {
        case open_drawer:
            return {...state, isDrawerOpen: true};
        case close_drawer:
            return {...state, isDrawerOpen: false};
        case open_btm_drawer:
            return {...state, isBtmDrawerOpen: true};
        case close_btm_drawer:
            return {...state, isBtmDrawerOpen: false};
        case toggle_drawer_Pin:
            return {...state, isDrawerPin: !state.isDrawerPin};
        case toggle_drawer_Fix:
            return {...state, isDrawerFix: !state.isDrawerFix};
        case drawer_content:
            return {...state, currentTab: action.payload};
        case drawer_Filters:
            return {...state, filters: action.payload};
        default:
            return state
    }
} 